// "How did you hear about the SEED Foundation?"
//
// Shown once, straight after signing up, as it was in the original. It is how the foundation
// learns which of its outreach actually reaches people -- twenty years and 21,719 answers of
// it -- and the answer is worth almost nothing if asked later, when nobody remembers.
//
// The answer is stored with no link to the applicant.

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';
import { api } from '../api.ts';
import { ErrorNotice, Loading, Field, Select, TextInput } from '../components/Bits.tsx';

export function HeardAbout() {
  const navigate = useNavigate();
  const [found, setFound] = useState("Don't Remember");
  const [other, setOther] = useState('');

  const options = useQuery({
    queryKey: ['survey', 'options'],
    queryFn: () => api.get<{ heardAbout: string[] }>('/api/survey/options'),
  });

  const save = useMutation({
    mutationFn: () => api.post('/api/survey/heard-about', { found, other }),
    onSuccess: () => navigate('/apply'),
  });

  if (options.isPending) return <main className="narrow" id="main"><Loading /></main>;

  return (
    <main className="narrow" id="main">
      <h2>One quick question</h2>
      <p className="lede">
        Before you start — how did you hear about the SEED Foundation? It helps us reach the
        next year's applicants, and it is not part of your application.
      </p>

      <ErrorNotice error={save.error} />

      <form className="panel" onSubmit={(e) => { e.preventDefault(); save.mutate(); }}>
        <Field label="How did you hear about us?">
          <Select value={found} onChange={(e) => setFound(e.target.value)}>
            {(options.data?.heardAbout ?? []).map((o) => (
              <option key={o} value={o}>{o}</option>
            ))}
          </Select>
        </Field>

        {found === 'Other' && (
          <Field label="Please describe">
            <TextInput value={other} onChange={(e) => setOther(e.target.value)} autoFocus />
          </Field>
        )}

        <div className="actions">
          <button type="submit" disabled={save.isPending}>
            {save.isPending ? 'Saving…' : 'Continue to the application'}
          </button>
          <button type="button" className="quiet" onClick={() => navigate('/apply')}>
            Skip
          </button>
        </div>
      </form>
    </main>
  );
}
